import { render, staticRenderFns } from "./BaseTextArea.vue?vue&type=template&id=5b081e2c&scoped=true&"
import script from "./BaseTextArea.vue?vue&type=script&lang=ts&"
export * from "./BaseTextArea.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTextArea.vue?vue&type=style&index=0&id=5b081e2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b081e2c",
  null
  
)

export default component.exports